import { HttpRequest } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface IAuthService {
    userToken$: BehaviorSubject<any | null>;
    userInfo$: BehaviorSubject<any | null>;

    refreshToken(): Observable<any>;
    injectAuth(request: HttpRequest<any>): HttpRequest<any>;
}

export const AUTH_SERVICE_TOKEN = new InjectionToken<IAuthService>('AUTH_SERVICE');
